import _typeof from "@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { toRefs } from 'vue';
import { useScreenPlugin } from '@/plugins/vue-screen';
import AppTitle from '@/shared/ui/AppTitle.vue';
export default {
  name: 'TitleHero',
  components: {
    AppTitle: AppTitle
  },
  props: {
    emitReset: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    titleWrapperOuterStyle: {
      type: String,
      default: undefined
    },
    values: {
      type: Object,
      default: function _default() {
        return {
          work_period: {},
          status: [],
          project: [],
          property_type: []
        };
      }
    },
    hasExpandedFilters: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup() {
    var _toRefs = toRefs(useScreenPlugin()),
      isMobile = _toRefs.isMobile;
    return {
      isMobile: isMobile
    };
  },
  data: function data() {
    return {
      isShowExpandedFilters: true,
      isShowFilters: true
    };
  },
  computed: {
    isResetDisabled: function isResetDisabled() {
      if (!this.values) {
        return false;
      }
      for (var val in this.values) {
        if (this.values[val] == null) {
          continue;
        }
        if (Array.isArray(this.values[val]) && this.values[val].length || _typeof(this.values[val]) === 'object' && Object.keys(this.values[val]).length || typeof this.values[val] === 'string' && Boolean(this.values[val].length)) {
          return false;
        }
      }
      return true;
    }
  },
  watch: {
    isMobile: function isMobile() {
      this.isShowExpandedFilters = true;
      this.isShowFilters = true;
    }
  },
  methods: {
    reset: function reset() {
      if (this.emitReset) {
        this.$emit('reset');
        return;
      }
      var emptyFilters = {};
      for (var key in this.values) {
        emptyFilters[key] = undefined;
      }
      this.$emit('change', emptyFilters);
    },
    showExpandedFilters: function showExpandedFilters() {
      this.isShowExpandedFilters = !this.isShowExpandedFilters;
    },
    showFilters: function showFilters() {
      this.isShowFilters = !this.isShowFilters;
    }
  }
};